import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

const Navigation = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  return (
    <nav className="bg-white/90 backdrop-blur-md shadow-lg sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <Link to="/cinnamon-design-1" className="flex items-center space-x-2 group">
            <div className="p-2 bg-gradient-to-br from-amber-500 to-orange-600 rounded-lg group-hover:scale-105 transition-transform duration-200 flex items-center justify-center">
              <svg className="h-6 w-6 text-white" fill="currentColor" viewBox="0 0 24 24">
                <path d="M12 2L13.09 8.26L22 9L13.09 9.74L12 16L10.91 9.74L2 9L10.91 8.26L12 2Z"/>
                <path d="M12 16C12 16 8 18 8 22H16C16 18 12 16 12 16Z"/>
              </svg>
            </div>
            <span className="text-xl font-bold bg-gradient-to-r from-amber-700 to-orange-700 bg-clip-text text-transparent">
              Claude's Special
            </span>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            <Link
              to="/cinnamon-design-1"
              className={`px-3 py-2 rounded-md text-sm font-medium transition-colors duration-200 ${
                isActive('/cinnamon-design-1') 
                  ? 'text-amber-700 bg-amber-100' 
                  : 'text-gray-700 hover:text-amber-700 hover:bg-amber-50'
              }`}
            >
              Home
            </Link>
            <Link
              to="/ceylon-cinnamon-design-1"
              className={`px-3 py-2 rounded-md text-sm font-medium transition-colors duration-200 ${
                isActive('/ceylon-cinnamon-design-1') 
                  ? 'text-amber-700 bg-amber-100' 
                  : 'text-gray-700 hover:text-amber-700 hover:bg-amber-50'
              }`}
            >
              Ceylon Cinnamon
            </Link>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="text-gray-700 hover:text-amber-700 transition-colors duration-200"
            >
              {isOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isOpen && (
          <div className="md:hidden">
            <div className="px-2 pt-2 pb-3 space-y-1 bg-white rounded-lg shadow-lg mt-2">
              <Link
                to="/cinnamon-design-1"
                onClick={() => setIsOpen(false)}
                className={`block px-3 py-2 rounded-md text-base font-medium transition-colors duration-200 ${
                  isActive('/cinnamon-design-1') 
                    ? 'text-amber-700 bg-amber-100' 
                    : 'text-gray-700 hover:text-amber-700 hover:bg-amber-50'
                }`}
              >
                Home
              </Link>
              <Link
                to="/ceylon-cinnamon-design-1"
                onClick={() => setIsOpen(false)}
                className={`block px-3 py-2 rounded-md text-base font-medium transition-colors duration-200 ${
                  isActive('/ceylon-cinnamon-design-1') 
                    ? 'text-amber-700 bg-amber-100' 
                    : 'text-gray-700 hover:text-amber-700 hover:bg-amber-50'
                }`}
              >
                Ceylon Cinnamon
              </Link>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navigation;